import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import CIcon from '@coreui/icons-react'
import { cilSend, cilPlus, cilMinus } from '@coreui/icons'
import { CButton, CCardText, CCol, CRow } from '@coreui/react'
import apiClient from '../../services/apiClient'
import { buildApiUrl } from '../../utils/getConfiguration'

const WidgetFinance = (props) => {
  const [moneyrequests, setMoneyrequests] = useState([])

  const fetchMoneyrequestsData = async () => {
    try {
      // Example: buildApiUrl('accountFinances', {
      //   account_ID: localStorage.getItem('account_ID'),
      //   grp_ID: localStorage.getItem('grp_ID'),
      // })
      const account_ID = localStorage.getItem('account_ID')
      const grp_ID = localStorage.getItem('grp_ID')
      const response = await apiClient.get(
        buildApiUrl('accountFinances', {
          account_ID,
          grp_ID,
        }),
      )
      //window.location.reload()
      setMoneyrequests(response.data)
    } catch (error) {
      console.error('Error fetching recommendations', error)
    }
  }

  useEffect(() => {
    fetchMoneyrequestsData()
  }, [])

  return (
    <CRow>
      <div className="d-grid gap-2 d-md-flex justify-content-md-end">
        {moneyrequests.length > 0 && (
          <CCol>
            {moneyrequests.map((moneyrequest) => (
              <>
                {moneyrequest.finance_id === props.parameter && (
                  <>
                    <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                      <CCardText className="p-1">Money request:</CCardText>
                      <CButton
                        color="info"
                        onClick={() => {
                          //if (Number(1000) > 1000) {
                          console.log('Amount MINUS')
                          console.log('Task Detail ')
                          //localStorage.setItem('taskid', moneyrequest.finance_id)
                          localStorage.setItem(
                            'FinanceAmount',
                            Number(moneyrequest.financeAmount) - 1000,
                          )
                          window.location.reload()
                          //handleClickPostpone()
                          //}
                        }}
                      >
                        <CIcon icon={cilMinus} size="xxl" />
                      </CButton>
                      <div className="p-1">{moneyrequest.financeAmount}.</div>
                      <div className="p-1">{localStorage.getItem('FinanceAmount')}.</div>
                      <CButton
                        color="info"
                        onClick={() => {
                          //if (Number(moneyrequest.expecteddate) < 12) {
                          console.log('Amount PLUS')
                          console.log('Task Detail ')
                          //localStorage.setItem('taskid', moneyrequest.finance_id)
                          localStorage.setItem(
                            'FinanceAmount',
                            Number(moneyrequest.financeAmount) + 1000,
                          )
                          window.location.reload()
                          //handleClickPostpone()
                          //}
                        }}
                      >
                        <CIcon icon={cilPlus} size="xxl" />
                      </CButton>
                      <div className="p-1"> $ </div>
                      <div className="p-1">Loan length:</div>
                      <CButton
                        color="info"
                        onClick={() => {
                          //if (Number(1000) > 1000) {
                          console.log('Month MINUS')
                          console.log('Task Detail ')
                          //localStorage.setItem('taskid', moneyrequest.finance_id)
                          localStorage.setItem(
                            'AImonth',
                            Number(localStorage.getItem('AImonth')) - 1,
                          )
                          window.location.reload()
                          //handleClickPostpone()
                          //}
                        }}
                      >
                        <CIcon icon={cilMinus} size="xxl" />
                      </CButton>
                      <div className="p-1">{moneyrequest.financeLenght}</div>
                      <div className="p-1">{localStorage.getItem('AImonth')}.</div>
                      <CButton
                        color="info"
                        onClick={() => {
                          //if (Number(moneyrequest.expecteddate) < 12) {
                          console.log('Month PLUS')
                          console.log('Task Detail ')
                          //localStorage.setItem('taskid', moneyrequest.finance_id)
                          localStorage.setItem(
                            'AImonth',
                            Number(localStorage.getItem('AImonth')) + 1,
                          )
                          window.location.reload()
                          //handleClickPostpone()
                          //}
                        }}
                      >
                        <CIcon icon={cilPlus} size="xxl" />
                      </CButton>
                      <div className="p-1"> months </div>
                    </div>
                    <hr></hr>
                    <div>
                      <div className="p-1">Parameters:</div>
                      <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <div className="p-1">Loan interest:</div>
                        <div className="p-1">{moneyrequest.financeInterest}%</div>
                      </div>
                      <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <div className="p-1">Loan amount:</div>
                        <div className="p-1">{moneyrequest.financeAmount} $</div>
                      </div>
                      <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <div className="p-1">Loan lenght:</div>
                        <div className="p-1">{moneyrequest.financeLenght} months</div>
                      </div>
                      <div className="d-grid gap-1 d-md-flex justify-content-md-end">
                        <div className="p-1">Send:</div>
                        <CButton
                          color="success"
                          onClick={() => {
                            console.log('Send request ')
                            //localStorage.setItem('taskid', recommendation.reminder_ID)
                            //handleClickDone()
                          }}
                        >
                          <CIcon icon={cilSend} size="xxl" />
                        </CButton>
                      </div>
                    </div>
                  </>
                )}
              </>
            ))}
          </CCol>
        )}
      </div>
    </CRow>
  )
}

WidgetFinance.propTypes = {
  parameter: PropTypes.string.isRequired,
}
export default WidgetFinance
